import { useMatches } from 'react-router-dom';

/** O que cada rota declara no `handle` do roteador: o título da página. */
export interface RouteHandle {
  title: string;
}

function isRouteHandle(value: unknown): value is RouteHandle {
  return typeof value === 'object' && value !== null && 'title' in value;
}

/**
 * Título da página atual, declarado na rota — fonte única para a trilha de navegação e para o
 * título da aba. Declarado no roteador, e não pela página: a trilha aparece antes de a página
 * carregar os dados, e ninguém esquece de defini-lo ao criar uma tela.
 */
export function useRouteTitle(): string | undefined {
  const matches = useMatches();
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const handle = matches[index]?.handle;
    if (isRouteHandle(handle)) return handle.title;
  }
  return undefined;
}
